import common from './common';
import forms from './forms';

export const Language_DE = {
  common,
  forms,
};
